'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var debug = require('debug');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var debug__default = /*#__PURE__*/_interopDefaultLegacy(debug);

/* eslint-disable no-console */
const logErrorDebug = debug__default["default"]('mp-sdk:error');
const logInfoDebug = debug__default["default"]('mp-sdk:info');
const logDebug = debug__default["default"]('mp-sdk:debug');
const logTrace = debug__default["default"]('mp-sdk:trace');
const logError = logErrorDebug.enabled ? logErrorDebug : console.error.bind(console);
const logInfo = logInfoDebug.enabled ? logInfoDebug : console.log.bind(console);

exports.logDebug = logDebug;
exports.logError = logError;
exports.logErrorDebug = logErrorDebug;
exports.logInfo = logInfo;
exports.logInfoDebug = logInfoDebug;
exports.logTrace = logTrace;
//# sourceMappingURL=log.cjs.map
